module.exports = __webpack_public_path__ + "img/trading-background-img.c190c191.svg";